import React, { useState, useEffect } from "react";
import Hotels from "./Hotels";
import Symbol from "./Symbol";
import Text from "./Text";

function Topbar({ isBlurred = false }) {
  const [isVisible, setIsVisible] = useState(true);

  // Handle closing the banner
  const closeBanner = () => {
    setIsVisible(false);
  };

  // Apply the push-down effect to the main content
  useEffect(() => {
    // Get the main content element (the parent div in your App component)
    const mainContent = document.querySelector('.App') || document.body;
    
    if (isVisible) {
      // Add padding to the top of the main content when banner is visible
      mainContent.style.paddingTop = "10vh";
      mainContent.style.transition = "padding-top 0.3s ease";
    } else {
      // Remove padding when banner is closed
      mainContent.style.paddingTop = "0";
    }
    
    // Cleanup function
    return () => {
      mainContent.style.paddingTop = "0";
    };
  }, [isVisible]);

  // If banner is not visible, don't render anything
  if (!isVisible) return null;

  return (
    <div
      className={`fixed top-0 left-0 w-full z-[100] flex items-center justify-between px-4 md:px-8 ${isBlurred ? "backdrop-blur-sm" : ""}`}
      style={{
        height: window.innerWidth <= 768 ? "6vh" : "8vh",
        background:
          "linear-gradient(180deg, #5B1DEE 0%, #341188 100%), linear-gradient(180deg, rgba(0, 0, 0, 0) 32.81%, rgba(0, 0, 0, 0.1) 100%)",
        transition: "transform 0.3s ease",
      }}
    >
      <div className="hidden md:block">
        <Hotels />
      </div>

      <div className="flex items-center justify-center text-white font-medium text-xs sm:text-sm md:text-base gap-2 md:gap-3">
        <span className="flex items-center">
          <Symbol />
        </span>
        <span className="whitespace-nowrap">
          RWA &amp; Crypto Perpetual Trading is Live!
        </span>
        <span className="text-white/70">→</span>
        <button
          className="ml-1 inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/10 px-4 py-1 text-xs sm:text-sm font-semibold hover:bg-white/20 transition-colors"
          onClick={() => window.open("https://app.codedestate.com/perps/market", "_blank")}
        >
          <span>Trade now</span>
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect x="4" y="10" width="2" height="6" rx="1" fill="white" />
            <rect x="9" y="7" width="2" height="9" rx="1" fill="white" />
            <rect x="14" y="9" width="2" height="7" rx="1" fill="white" />
            <path
              d="M5 6L9 4L13 6L17 5"
              stroke="white"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </div>

      <button
        onClick={closeBanner}
        className="text-white hover:text-gray-200 focus:outline-none"
      >
        <svg 
          xmlns="http://www.w3.org/2000/svg" 
          width="24" 
          height="24" 
          viewBox="0 0 24 24" 
          fill="none" 
          stroke="currentColor" 
          strokeWidth="2" 
          strokeLinecap="round" 
          strokeLinejoin="round"
        >
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
    </div>
  );
}

export default Topbar;